import { createAction, createReducer, PayloadAction } from '@reduxjs/toolkit'

export interface Document {
  id: string
  vehicle_name: string
  motorbike_id?: string | number | null
  created_at: string
  document_type: string
  client_id?: string | number | null
}

export type PdfIntent = 'open' | 'download'

export interface DocumentsReducer {
  documents: Document[]
  totalPages: number
  currentPage: number
  totalCount: number
  loading: boolean
  pdf_url: string
  pdf_intent: PdfIntent
}

const initialState: DocumentsReducer = {
  documents: [],
  totalPages: 0,
  currentPage: 1,
  totalCount: 0,
  loading: false,
  pdf_url: '',
  pdf_intent: 'open'
}

interface FetchDocumentsPayload {
  clientId?: string
  motorbikeId?: string
}
export type FetchDocumentsActionType = PayloadAction<FetchDocumentsPayload>
export const FETCH_DOCUMENTS = createAction<FetchDocumentsPayload>('documents_reducer/fetch_documents')

interface FetchDocumentsSuccessPayload {
  documents: Document[]
  totalPages: number
  totalCount: number
  page: number
}

export const FETCH_DOCUMENTS_SUCCESS = createAction<FetchDocumentsSuccessPayload>(
  'documents_reducer/fetch_documents_success'
)
export const FETCH_DOCUMENTS_FAILURE = createAction('documents_reducer/fetch_documents_failure')
export const SET_CURRENT_PAGE = createAction<number>('documents_reducer/set_current_page')
export const RESET_PDF_URL = createAction('documents_reducer/reset_pdf_url')

interface FetchPdfUrlPayload {
  id: string
  document_type: string
  intent: PdfIntent
}
export type FetchPdfUrlActionType = PayloadAction<FetchPdfUrlPayload>
export const FETCH_PDF_URL = createAction<FetchPdfUrlPayload>('documents_reducer/fetch_pdf_url')

interface FetchPdfUrlSuccessPayload {
  pdf_url: string
}
export const FETCH_PDF_URL_SUCCESS = createAction<FetchPdfUrlSuccessPayload>('documents_reducer/fetch_pdf_url_success')
export const FETCH_PDF_URL_FAILURE = createAction('documents_reducer/fetch_pdf_url_failure')

interface DeleteDocumentPayload {
  id: string
  document_type: string
  motorbikeId?: string
  clientId?: string
}
export type DeleteDocumentActionType = PayloadAction<DeleteDocumentPayload>
export const DELETE_DOCUMENT = createAction<DeleteDocumentPayload>('documents_reducer/delete_document')
export const DELETE_DOCUMENT_SUCCESS = createAction('documents_reducer/delete_document_success')
export const DELETE_DOCUMENT_FAILURE = createAction('documents_reducer/delete_document_failure')

export const documentsReducer = createReducer(initialState, (builder) => {
  builder
    .addCase(FETCH_DOCUMENTS, (state) => {
      state.loading = true
    })
    .addCase(FETCH_DOCUMENTS_SUCCESS, (state, action) => {
      state.loading = false
      state.documents = action.payload.documents
      state.totalPages = action.payload.totalPages
      state.totalCount = action.payload.totalCount
      state.currentPage = action.payload.page
    })
    .addCase(FETCH_DOCUMENTS_FAILURE, (state) => {
      state.loading = false
      state.documents = []
    })
    .addCase(SET_CURRENT_PAGE, (state, action) => {
      state.currentPage = action.payload
    })
    .addCase(RESET_PDF_URL, (state) => {
      state.pdf_url = ''
      state.pdf_intent = 'open'
    })
    .addCase(FETCH_PDF_URL, (state, action) => {
      state.pdf_url = ''
      state.pdf_intent = action.payload.intent
    })
    .addCase(FETCH_PDF_URL_SUCCESS, (state, action) => {
      state.loading = false
      state.pdf_url = action.payload.pdf_url
    })
    .addCase(DELETE_DOCUMENT, (state) => {
      state.loading = true
    })
    .addCase(DELETE_DOCUMENT_SUCCESS, (state) => {
      state.loading = false
    })
    .addCase(DELETE_DOCUMENT_FAILURE, (state) => {
      state.loading = false
    })
})
